import { DEFAULT_STATE } from '../constants'

export const initialMoreFiltersState = {
  advancedFilters: DEFAULT_STATE.advancedFilters,
  personalFilters: DEFAULT_STATE.personalFilters,
  purchaseFilter: DEFAULT_STATE.purchaseFilter,
}
